<template>
  <div id="app">
    <HeaderComponent />
    <router-view />
    <FooterComponent />
    <ContactSupportComponent />
  </div>
</template>

<script>
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.min.js";
import { HeaderComponent, FooterComponent } from "./components";
import ContactSupportComponent from "./components/ContactSupport/ContactSupportComponent.vue";

export default {
  components: {
    HeaderComponent,
    FooterComponent,
    ContactSupportComponent
  },
  data() {
    return {};
  },
  mounted() {
    let script = document.createElement("script");
    script.setAttribute("src", "https://www.youtube.com/iframe_api");
    script.id = "youtube-iframe-api";
    if (!document.querySelector("#youtube-iframe-api"))
      document.body.appendChild(script);
  },
};
</script>

<style>
@import "./assets/fonts/fonts.css";
:root {
  --gray-bg-color: #f5f5f0;
}
body {
  direction: rtl;
  font-family: "Cairo";
  overflow-x: hidden;
  background: var(--gray-bg-color);
  position: relative;
}
#app {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

input:focus::placeholder {
  color: transparent !important;
}
/* body {
  direction: rtl;
  font-family: "globalFont", sans-serif;
  overflow-x: hidden;
  position: relative;
  background-color: #f5f5f5;
  color: #1e1e1e;
} */
body.dark {
  background-color: #0c0c0c;
  /* transition: all 0.3s ease-in-out; */
  position: relative;
}
.lg-hidden {
  display: none;
}
.input {
  width: 100%;
  display: flex;
  align-items: center;
  /* justify-content: space-between; */
  border-bottom: 1.5px solid #1e1e1e;
  margin-bottom: 30px;
  /* padding: 5px 0; */
  position: relative;
}
.input input {
  all: unset;
  width: 90%;
  padding: 10px 0;
  color: #1e1e1e;
}
body.dark .input input {
  color: #dad2c5;
}
.clear-input {
  color: #919191;
  cursor: pointer;
  margin: 0;
  position: absolute;
  top: 50%;
  left: 0;
  transform: translateY(-50%);
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
/* Swiper */
.swiper-button-prev,
.swiper-button-next {
  position: absolute;
  top: 50% !important;
  transform: translateY(-50%);
  width: 73px !important;
  height: 128px !important;
  margin-top: 0 !important;
  z-index: 10;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ffffff !important;
  background-color: #00000080 !important;
  transition: all 0.5s ease-in-out !important;
}
.swiper-button-prev:hover,
.swiper-button-next:hover {
  background-color: #000000 !important;
  transition: all 0.5s ease-in-out !important;
}
.swiper-button-prev {
  right: 0 !important;
  border-radius: 20px 0 0 20px !important;
}
.swiper-rtl .swiper-button-prev {
  right: 0 !important;
}
.swiper-button-next {
  left: 0 !important;
  border-radius: 0 20px 20px 0 !important;
}
/* Dark Mode */
body.dark .input {
  border-color: #ffffff50;
}
body.dark .swal2-popup.swal2-modal {
  background-color: #1e1e1e;
  color: #fff;
}
/* Media Queries */
@media (max-width: 767px) {
  .lg-hidden {
    display: block;
  }
  .sm-hidden {
    display: none;
  }
  .swiper-button-prev,
  .swiper-button-next {
    width: 50px !important;
    height: 105px !important;
  }
  .swiper-button-prev:after,
  .swiper-button-next:after {
    font-size: 1.5rem !important;
  }
}
</style>
